/* eslint-disable react/prop-types */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import React, { useContext, useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch } from "react-redux";
import { Box, TableCell, TableRow } from "@mui/material";
import EditIcon from "../../../assets/svg/Edit";
import Styles, { tableStyles } from "./ViewAnnouncement.Style";
import Toast from "../../../components/common/Toast";
import Table from "../../../components/common/new/Table/Table";
import { ANNOUNCEMENT_CYCLE_COL } from "../../../contants/table/appointment";
import { SET_VIEW_ANNOUNCEMENT_CYCLE_DATA } from "../../../redux/actionTypes/dashboard";
import Typography from "../../../components/common/new/Typography/Typography";
import UpdateAnnouncementModal from "./UpdateAnnouncementModal";
import CreateAnnouncementCycle from "../CreateAnnouncement/CreateAppointmentCycle";
import Button from "../../../components/common/Button";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Announcement from "../../../services/api/announcement";
import { AlertStatus } from "../../../contants";
import Loader from "../../../components/common/Loader/Loader";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = (data, onViewUpdateAnnouncementCycle) =>
  data.map((announcementInfo) => (
    <TableRow style={tableStyles.tableRow}>
      <TableCell style={tableStyles.tableCell}>
        {" "}
        {announcementInfo.module}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.structureLevel || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.examLevel || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.startDate || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.endDate || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.examDate || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.createdByName || "-"}{" "}
      </TableCell>
      <TableCell style={tableStyles.tableCell}>
        {announcementInfo.active === true ? "YES" : "NO" || "-"}{" "}
      </TableCell>
      <TableCell style={tabelCellWidth.medium}>
        {" "}
        <div style={tableStyles.actionButtons}>
          <VisibilityIcon
            style={tableStyles.actionIcon}
            onClick={() =>
              onViewUpdateAnnouncementCycle(announcementInfo, "view")
            }
          />
          <EditIcon
            style={tableStyles.actionIcon}
            onClick={() =>
              onViewUpdateAnnouncementCycle(announcementInfo, "edit")
            }
          />
        </div>
      </TableCell>
    </TableRow>
  ));

export default function ViewAnnouncement() {
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(null);
  const [openCreateAnnouncement, setOpenCreateAnnouncement] = useState(false);
  const [openViewUpdateModal, setOpenViewUpdateModal] = useState(false);
  const [currentModalType, setCurrentModalType] = useState("");
  const [showNoResult, setShowNoResult] = useState(false);
  const [search, setSearch] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAnnouncementData = async () => {
    try {
      setIsLoading(true);
      const data = await Announcement.getAnnouncementCycle({});
      setSearch(data?.data?.content);
      setTimeout(() => {
        // onRefresh();
        // setModalOpen(false);
      }, 2000);
      setIsLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      // Sentry.captureException(error);
    }
  };

  const onRefresh = () => {
    fetchAnnouncementData();
  };

  const [selectedRow, setSelectedRow] = useState(null);
  // const announcement = useSelector((state) => state.view_announcement.data);

  const closeViewUpdateAnnouncementModal = () => {
    setOpenViewUpdateModal(false);
  };

  const toggleCreateAnnouncementModal = () => {
    setOpenCreateAnnouncement((prev) => !prev);
  };

  const onViewUpdateAnnouncementCycle = (row, type) => {
    setSelectedRow(row, type);
    setCurrentModalType(type);
    setOpenViewUpdateModal(true);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowNoResult(!showNoResult);
    }, 2000);
  }, []);

  useEffect(() => {
    fetchAnnouncementData(dispatch);
  }, []);

  useEffect(() => {
    dispatch({
      type: SET_VIEW_ANNOUNCEMENT_CYCLE_DATA,
      payload: [],
    });
  }, []);

  return (
    <div style={Styles.container}>
      {isLoading && <Loader />}
      <Box style={Styles.left}>
        <Typography variant="title3" color="#8c8c8c">
          View Announcements
        </Typography>

        <Box style={Styles.right}>
          <Button
            style={{ width: "200px" }}
            onClick={toggleCreateAnnouncementModal}
            label="Create Announcement"
          />
        </Box>
      </Box>
      {search?.length ? (
        <Box mt={4} style={Styles.tableContainer}>
          <Table
            scrollable
            columns={ANNOUNCEMENT_CYCLE_COL}
            rows={getRows(
              search,
              // onAnnouncementCycle,
              onViewUpdateAnnouncementCycle,
              toggleCreateAnnouncementModal
            )}
            selectedRow={selectedRow}
            hasAction
          />
          <Toast
            open={!!showToast}
            severity={showToast?.severity || ""}
            message={showToast?.message || ""}
            handleClose={() => {
              setShowToast(null);
            }}
          />
          <UpdateAnnouncementModal
            open={openViewUpdateModal}
            onClose={closeViewUpdateAnnouncementModal}
            selectedRow={selectedRow}
            refresh={onRefresh}
            currentModalType={currentModalType}
            setShowToast={setShowToast}
          />
        </Box>
      ) : (
        <Box style={Styles.emptyContainer}>
          {showNoResult && <h1 style={Styles.noDataMsg}>No Results</h1>}
        </Box>
      )}
      <CreateAnnouncementCycle
        open={openCreateAnnouncement}
        onClose={toggleCreateAnnouncementModal}
        setShowToast={setShowToast}
        toast={toast}
        refresh={onRefresh}
      />
    </div>
  );
}
